import { isArray } from '../shortcut'
import { Path } from './path'

import type { PathLikes, PathParts } from './types'

export function getHash(path: PathLikes, prefix?: string): string {
  const suffix =
    typeof path === 'string'
      ? path
      : isArray(path)
        ? path.join(',')
        : String(path)
  return prefix ? `${prefix}:${suffix}` : suffix
}

export function getSource(parts: PathParts, defaultSource: string): string {
  return parts.absolute
    ? `/${parts.join('/')}`
    : parts.join('/') || defaultSource
}

export function normalize(queue: PathLikes[], resolveMode: boolean): PathParts {
  const result: PathParts = []
  if (resolveMode) result.absolute = true
  while (queue.length > 0) {
    const part = queue.shift()!
    if (isArray(part)) queue.unshift(...part)
    else if (typeof part === 'symbol' || typeof part === 'number')
      result.push(part)
    else if (part === '' || part === undefined) continue
    else {
      const path = part instanceof Path
      const parts = path ? part.parts : part.split(/[/\\]+/)
      const absolute = path || part[0] === '/'
      result.absolute ??= absolute
      if (absolute && resolveMode) result.length = 0
      while (parts[0] === '') parts.shift()
      while (parts.at(-1) === '') parts.pop()
      for (const part of parts) {
        switch (part) {
          case 0: {
            result.push(part)
            break
          }
          case '.': {
            continue
          }
          case '..': {
            if (result.length > 0 && result.at(-1) !== '..') result.pop()
            else if (!result.absolute) result.push(part)
            break
          }
          default: {
            if (part) result.push(part)
          }
        }
      }
    }
  }
  return result
}
